export default __webpack_public_path__ + "static/preview_ja-15f116aa1148d39cd76e51a274376d8f.jpg";